import { useEffect, useMemo } from 'react';
import { logger } from 'src/utils/logger';
import { MixpanelEvents } from '../Events/MixpanelEvents';
import { isEnriched, useEnrichEvent } from '../useEnrichEvent';
import { shouldIgnoreMixpanel, useMixpanel } from '../useMixpanel';

export const useTrackPageViews = () => {
  const { mixpanel, route } = useMixpanel();

  const { enrichEvent } = useEnrichEvent();

  // Let's create the rich event once. This holds the tenant code, user role, etc.
  const richEvent = useMemo(() => enrichEvent(MixpanelEvents.general.PAGE_VIEW), [enrichEvent]);

  // If the route is different, track the page view
  useEffect(() => {
    if (route && mixpanel && !shouldIgnoreMixpanel && isEnriched(richEvent)) {
      try {
        mixpanel.track_pageview({ page: route, ...richEvent });
      } catch (e) {
        logger.log('Mixpanel was not initialized correctly:', e);
      }
    }
  }, [route, mixpanel, richEvent]);
};
